import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ProductSubNav } from "@/components/portal/ProductSubNav";
import { messagingSubNav } from "@/lib/navigationItems";

export const Route = createFileRoute("/portal/messaging")({
  component: MessagingLayout,
});

function MessagingLayout() {
  return (
    <div className="space-y-4">
      <ProductSubNav items={messagingSubNav} />
      <Outlet />
    </div>
  );
}
